export default __webpack_public_path__ + "static/media/logo-v2.93aa2b15.svg";